import React from 'react';
import {Styles} from '../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../../config/Translate";
import AppAnimate from "../../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import VisitsChart from "../../../components/charts/VisitsChart";
import Title from "../../../components/elements/Title";
import Clock from "../../../components/elements/Clock";
import PeopleRoundedIcon from '@material-ui/icons/PeopleRounded';
import AppCard from "../../../components/layouts/components/AppCard";
import Button from "@material-ui/core/Button/Button";
import LiveUsers from "./components/LiveUsers";
import TodayAnalytics from "./components/TodayAnalytics";
import OrdersAnalytics from "./components/OrdersAnalyticsShort";
import OrdersChart from "../../../components/charts/OrdersChart";
import Permission from "../../../components/elements/Permission";
import Feature from "../../../components/elements/Feature";
import ToDos from "./components/ToDos";
import {Link, withRouter} from "react-router-dom";
import Badge from "@material-ui/core/Badge";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {connect} from "trim-redux";
import {updateRedux} from "../../../../config/Security";
import EmailRoundedIcon from '@material-ui/icons/EmailRounded';
import SubTitle from "../../../components/elements/SubTitle";
class AdminDashboard extends React.Component {
    classes = this.props.classes;
    componentDidMount() {
        updateRedux()
    }

    render(){
        let {user} = this.props;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12} style={{display:"flex",justifyContent:"flex-end"}}>
                        <Button
                            color="primary"
                            size="small"
                            variant="contained"
                            style={{margin:"0 10px",/*backgroundColor:"#1640d6",color:"#fff",borderColor:"#1640d6 !important"*/}}
                            component="a"
                            href="https://epanjere.com/webmail"
                            target="_blank"
                            startIcon={<EmailRoundedIcon color="secondary" style={{marginBottom:2,fontSize:16}}/>}
                        >
                            {Translate.webmail}
                        </Button>

                        <Badge
                            color="secondary"
                            badgeContent={user.umc}
                            className="ticket_badge"
                            anchorOrigin={{
                                vertical: 'top',
                                horizontal: 'left',
                            }}
                        >
                            <Button
                                color="primary"
                                size="small"
                                variant="contained"
                                component={Link}
                                to='/tickets'
                            >
                                {/*{Translate.viewTickets}*/}
                                Ticket
                            </Button>
                        </Badge>
                    </Grid>
                    <Feature check="marketplace">
                        <Permission rule="manageSettings">
                            <Grid item xs={12}>
                                <OrdersAnalytics beginDate={''} endDate={''}/>
                            </Grid>
                        </Permission>
                    </Feature>
                    <Grid item xs={12}>
                        <ToDos/>
                    </Grid>
                        <Grid item xs={12} md={9}>
                            <AppCard>
                                <SubTitle align="left">
                                    {Translate.visitsChart}
                                </SubTitle>
                                <div style={{height:300,direction:"ltr"}}>
                                    <VisitsChart/>
                                </div>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12} md={3} >
                            <AppCard
                                style={{height:"100%"}}>
                                <Title><PeopleRoundedIcon fontSize="large"/> <br/> {Translate.liveUsers} </Title>
                                <Grid item xs={12} >
                                    <Clock/>
                                </Grid>
                                <Grid item xs={12} >
                                    <LiveUsers/>
                                </Grid>
                            </AppCard>
                        </Grid>
                        <Grid item xs={12}>
                            <TodayAnalytics/>
                        </Grid>
                    <Permission rule="manageSettings">
                        <Grid item xs={12}>
                            <OrdersChart/>
                        </Grid>
                    </Permission>
                </Grid>
            </AppAnimate>
        );
    }
}
const mstp = state => ({
    user: state.user,
});
export default  withRouter(withWidth()(withStyles(Styles)(connect(mstp)(AdminDashboard))));
